import Segment from './component';
import { lineTool } from '../shared/line';

export const tool = lineTool('segment', Segment);
